import{gql as e}from"@apollo/client";const s=e`
  query getUserNotes($userId: Int!) {
    note {
      getUserNotes: getByUser(userId: $userId) {
        attachments {
          asset {
            contentType
            assetId
            fileName
            fileSizeInBytes
            s3Key
            presignedUrl
          }
        }
        id
        message
        subject
      }
    }
  }
`;export{s as GET_USER_NOTES_QUERY};
//# sourceMappingURL=useGetUserNotes.graphql.js.map
